import {
    Box,
    Container,
    Heading,
    Text,
    Badge,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableContainer,
    VStack,
    HStack,
    Button,
    useColorModeValue,
    UnorderedList,
    ListItem,
    Card
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import Header from '../../components/Header';
import { Link } from 'react-router-dom';
import { fetchWrapper } from '../../helpers';

// Prism.js code highlighting component
const CodeBlock = ({ code, language = 'javascript' }) => {
    const [highlightedCode, setHighlightedCode] = useState('');


    useEffect(() => {
        // Simulate syntax highlighting (since we don't have actual Prism.js)
        // In a real implementation, you'd use Prism.highlight()
        const highlighted = code
            .replace(/"([^"]+)":/g, '<span style="color: #e06c75;">"$1"</span>:')
            .replace(/: "([^"]+)"/g, ': <span style="color: #98c379;">"$1"</span>')
            .replace(/: (\d+)/g, ': <span style="color: #d19a66;">$1</span>')
            .replace(/{/g, '<span style="color: #56b6c2;">{</span>')
            .replace(/}/g, '<span style="color: #56b6c2;">}</span>')
            .replace(/\[/g, '<span style="color: #56b6c2;">[</span>')
            .replace(/\]/g, '<span style="color: #56b6c2;">]</span>');

        setHighlightedCode(highlighted);
    }, [code]);

    return (
        <Box
            bg="gray.900"
            p={4}
            borderRadius="md"
            overflow="auto"
            fontFamily="mono"
            fontSize="sm"
            color="white"
        >
            <pre dangerouslySetInnerHTML={{ __html: highlightedCode }} />
        </Box>
    );
};

const MessageAPIDoc = ({ header }) => {
    const tableBg = useColorModeValue('gray.50', 'gray.700');
    const borderColor = useColorModeValue('gray.200', 'gray.600');
    const [apiKey, setApiKey] = useState('');
    const requestPayload = `{
    "to": "923358***5119",
    "message": "String",
    "parser_id": "33d220bd-0847-****-b703-5845933f126e",
    "payload_type": "text",
    "email": "(Optional)",
    "preferred_channel": "SMS (Remove this key when using smart/custom routing)"
}`;

    const responsePayload = `{
    "success": true,
    "status": "accepted",
    "messageid": "99645c91-8ed2-4a89-92ff-ac018678c500",
    "accepttime": 1749801275
}`;

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
    };
    const loadList = async () => {

        const url = `${process.env.REACT_APP_API_URL}/customer/get-key?key_type=api_key`;
        const data = await fetchWrapper.get(url)

        setApiKey(data?.key || '')

    }

    useEffect(() => {
        loadList()
    }, [])

    const Preferred_Channel = [

        {
            channel: 'SMS',
            value: 'SMS',
            description: 'SMS will be sent, overriding Custom Routing & Smart Routing'
        },
        {
            channel: 'WhatsApp',
            value: 'Whatsapp',
            description: 'WhatsApp will be sent, overriding Custom Routing & Smart Routing'
        },
        {
            channel: 'Mobile Push',
            value: 'Push Notification',
            description: 'Mobile Push Notification will be sent, overriding Custom Routing & Smart Routing'
        },
        {
            channel: 'Mobile In-App',
            value: 'In-App Notification',
            description: 'Mobile In-App Notification will be sent, overriding Custom Routing & Smart Routing'
        },
        {
            channel: 'Voice (IVR)',
            value: 'Voice (IVR)',
            description: 'Voice (IVR) will be sent, overriding Custom Routing & Smart Routing'
        },
        {
            channel: 'E-Mail',
            value: 'E-Mail',
            description: 'E-Mail will be sent, overriding Custom Routing & Smart Routing'
        },

    ];
    
    return (
        <>
            <Header header={header} />
            <Card className='card-style' style={{ margin: "20px 40px" }} shadow={'xl'}>
                <Container maxW="full" py={8} px={8}>
                    <VStack spacing={4} align="stretch">
                        {/* Header */}
                        <Box mb="20px">
                            <Text fontSize="32px" fontWeight="300" color="#000000" my="0px" >Message API Documentation</Text>
                        </Box>
                        <HStack >

                            <Box>
                                <Text fontSize="16px" fontWeight="600" color="#000000" my="0px" >End Point :</Text>
                            </Box>
                            <Box>
                                <Link color="#205EFF" fontSize="16px" fontWeight="400" my="0px"  href="#" style={{ color: "#205EFF" }}>{process.env.REACT_APP_SEND_API_URL}/v2/message</Link>
                            </Box>
                        </HStack>

                        <HStack >
                            <Box>
                                <Text fontSize="16px" fontWeight="600" color="#000000" my="0px" >Method : </Text>
                            </Box>
                            <Box>
                                <Badge borderRadius="30px" fontSize="14px" px="30px" py="5px" fontWeight="600" bg="#FF9A00" color="white" my="0px" >post</Badge>

                            </Box>
                        </HStack>

                        {/* Headers Section */}
                        <Box>
                            <Heading size="md" mb={4}>
                                Headers
                            </Heading>
                            <TableContainer>
                                <Table variant="simple" size="sm">
                                    <Thead bg={tableBg}>
                                        <Tr>
                                            <Th border={`1px solid ${borderColor}`}>Header</Th>
                                            <Th border={`1px solid ${borderColor}`}>Value</Th>
                                            <Th border={`1px solid ${borderColor}`}>Description</Th>
                                        </Tr>
                                    </Thead>
                                    <Tbody>
                                        <Tr>
                                            <Td border={`1px solid ${borderColor}`}>Content-Type</Td>
                                            <Td border={`1px solid ${borderColor}`}>application/json</Td>
                                            <Td border={`1px solid ${borderColor}`}>Specifies the format of the payload.</Td>
                                        </Tr>
                                        <Tr>
                                            <Td border={`1px solid ${borderColor}`}>X-api-key</Td>
                                            <Td border={`1px solid ${borderColor}`}>
                                                {apiKey}
                                                <br />
                                                <Text fontSize="xs" color="gray.500">This is your API Key</Text>
                                            </Td>
                                            <Td border={`1px solid ${borderColor}`}>Your unique API key for authentication.</Td>
                                        </Tr>
                                    </Tbody>
                                </Table>
                            </TableContainer>
                        </Box>

                        {/* Request Payload Section */}
                        <Box>
                            <Heading size="md" mb={4}>
                                Request Payload
                            </Heading>
                            <Text fontSize="sm" color="gray.600" mb={4}>
                                The request payload must be sent in JSON format, containing the recipient's number, message and template id
                            </Text>

                            <Box position="relative">
                                <CodeBlock code={requestPayload} />
                                <Button
                                    size="xs"
                                    position="absolute"
                                    top={2}
                                    right={2}
                                    colorScheme="blue"
                                    variant="outline"
                                    onClick={() => copyToClipboard(requestPayload)}
                                >
                                    Copy Payload
                                </Button>
                            </Box>
                        </Box>

                        <div style={{ "background-color": " #F0F4FF", "borderLeft": "4px solid #3366CC", "padding": "16px", "margin": "20px 0", "borderRadius": "6px" }}>
                            <strong>Need Help?</strong><br />
                            To find the correct <strong>parser_id</strong> and <strong>message</strong> for your API payload, please visit the <a href="/parser" target='_blank' style={{ "color": "#3366CC", "textDecoration": "underline" }}>Message Parser Listing</a> page.
                        </div>

                        {/* Payload Fields Section */}
                        <Box>
                            <Heading size="md" mb={4}>
                                Payload Fields
                            </Heading>
                            <TableContainer>
                                <Table variant="simple" size="sm">
                                    <Thead bg={tableBg}>
                                        <Tr>
                                            <Th border={`1px solid ${borderColor}`}>Field</Th>
                                            <Th border={`1px solid ${borderColor}`}>Type</Th>
                                            <Th border={`1px solid ${borderColor}`}>Required</Th>
                                            <Th border={`1px solid ${borderColor}`}>Description</Th>
                                        </Tr>
                                    </Thead>
                                    <Tbody>
                                        <Tr>
                                            <Td border={`1px solid ${borderColor}`}>to</Td>
                                            <Td border={`1px solid ${borderColor}`}>String</Td>
                                            <Td border={`1px solid ${borderColor}`}>Yes</Td>
                                            <Td border={`1px solid ${borderColor}`}>
                                                The recipient's phone number.
                                                <br />
                                                <Text fontSize="xs" color="gray.500">
                                                    Important: The number must be provided without a + sign
                                                </Text>
                                            </Td>
                                        </Tr>
                                        <Tr>
                                            <Td border={`1px solid ${borderColor}`}>message</Td>
                                            <Td border={`1px solid ${borderColor}`}>String</Td>
                                            <Td border={`1px solid ${borderColor}`}>Yes</Td>
                                            <Td border={`1px solid ${borderColor}`}>The Message Content.</Td>
                                        </Tr>
                                        <Tr>
                                            <Td border={`1px solid ${borderColor}`}>parser_id</Td>
                                            <Td border={`1px solid ${borderColor}`}>String</Td>
                                            <Td border={`1px solid ${borderColor}`}>Yes</Td>
                                            <Td border={`1px solid ${borderColor}`}>
                                                Sender ID is used to identify Sending Template and extract
                                                functions back to send WhatsApp Messages.
                                            </Td>
                                        </Tr>
                                        <Tr>
                                            <Td border={`1px solid ${borderColor}`}>payload_type</Td>
                                            <Td border={`1px solid ${borderColor}`}>String</Td>
                                            <Td border={`1px solid ${borderColor}`}>Yes</Td>
                                            <Td border={`1px solid ${borderColor}`}>This defines that this is a Text Based Messages</Td>
                                        </Tr>
                                        <Tr>
                                            <Td border={`1px solid ${borderColor}`}>email</Td>
                                            <Td border={`1px solid ${borderColor}`}>String</Td>
                                            <Td border={`1px solid ${borderColor}`}>No</Td>
                                            <Td border={`1px solid ${borderColor}`}>This defines that this is user email</Td>
                                        </Tr>
                                    </Tbody>
                                </Table>
                            </TableContainer>
                        </Box>
                        <Box mb="20px">
                            <div >
                                <Box mb="10px">
                                    <Text fontSize="20px" fontWeight="600" color="#000000" my="0px" >Preferred Channel</Text>
                                </Box>
                                <Text fontSize="14px" fontWeight="400" color="#000000" my="0px" >
                                    Following are the Values for “preferred_channel” in Request Payload
                                </Text>
                                <TableContainer width="100%">
                                    <Table variant="simple" size="sm">
                                        <Thead bg={tableBg}>
                                            <Tr>
                                                <Th>Channel</Th>
                                                <Th>Value</Th>
                                                <Th>Description</Th>
                                            </Tr>
                                        </Thead>

                                        <Tbody fontSize="14px">
                                            {Preferred_Channel.map((field, index) => (
                                                <Tr key={index}>
                                                    <Td>{field.channel}</Td>
                                                    <Td>{field.value}</Td>
                                                    {/* <Td>{field.description}</Td> */}
                                                    <Td>
                                                        <Text >{field?.description}</Text>
                                                    </Td>
                                                </Tr>
                                            ))}
                                        </Tbody>


                                    </Table>

                                </TableContainer>
                            </div>
                        </Box>
                        {/* Response Section */}
                        <Box>
                            <Heading size="md" mb={4}>
                                Response
                            </Heading>
                            <Text fontSize="sm" color="gray.600" mb={4}>
                                If the message is successfully sent, you will receive a response like this:
                            </Text>
                            <CodeBlock code={responsePayload} />
                        </Box>

                        {/* API Response Code Section */}
                        <Box>
                            <Heading size="md" mb={4}>
                                API Response Code
                            </Heading>
                            <TableContainer>
                                <Table variant="simple" size="sm">
                                    <Thead bg={tableBg}>
                                        <Tr>
                                            <Th border={`1px solid ${borderColor}`}>Status</Th>
                                            <Th border={`1px solid ${borderColor}`}>Status Code</Th>
                                            <Th border={`1px solid ${borderColor}`}>Description</Th>
                                        </Tr>
                                    </Thead>
                                    <Tbody>
                                        <Tr>
                                            <Td border={`1px solid ${borderColor}`}>accepted</Td>
                                            <Td border={`1px solid ${borderColor}`} color="green.500">200</Td>
                                            <Td border={`1px solid ${borderColor}`}>Message has been accepted and will be sent to Customer</Td>
                                        </Tr>
                                        <Tr>
                                            <Td border={`1px solid ${borderColor}`}>Content Missing</Td>
                                            <Td border={`1px solid ${borderColor}`} color="red.500">404</Td>
                                            <Td border={`1px solid ${borderColor}`}>message Field sent in Payload is Blank</Td>
                                        </Tr>
                                        <Tr>
                                            <Td border={`1px solid ${borderColor}`}>Phone Number Missing</Td>
                                            <Td border={`1px solid ${borderColor}`} color="red.500">404</Td>
                                            <Td border={`1px solid ${borderColor}`}>to Field sent in Payload is Blank</Td>
                                        </Tr>
                                        <Tr>
                                            <Td border={`1px solid ${borderColor}`}>Authentication Failed</Td>
                                            <Td border={`1px solid ${borderColor}`} color="red.500">401</Td>
                                            <Td border={`1px solid ${borderColor}`}>API key Missing, invalid API key or API key does not Exist in our Database</Td>
                                        </Tr>
                                        <Tr>
                                            <Td border={`1px solid ${borderColor}`}>Account Inactive</Td>
                                            <Td border={`1px solid ${borderColor}`} color="red.500">404</Td>
                                            <Td border={`1px solid ${borderColor}`}>Customer Account Mark as Inactive in the System</Td>
                                        </Tr>
                                        <Tr>
                                            <Td border={`1px solid ${borderColor}`}>Insufficient balance</Td>
                                            <Td border={`1px solid ${borderColor}`} color="red.500">404</Td>
                                            <Td border={`1px solid ${borderColor}`}>
                                                Customer do not have enough balance available or has reached their
                                                Credit limit
                                            </Td>
                                        </Tr>
                                    </Tbody>
                                </Table>
                            </TableContainer>
                        </Box>

                        {/* Other Information Section */}
                        <Box>
                            <Heading size="md" mb={4}>
                                Other Information
                            </Heading>
                            <TableContainer>
                                <Table variant="simple" size="sm">
                                    <Thead bg={tableBg}>
                                        <Tr>
                                            <Th border={`1px solid ${borderColor}`}>Key</Th>
                                            <Th border={`1px solid ${borderColor}`}>Description</Th>
                                        </Tr>
                                    </Thead>
                                    <Tbody>
                                        <Tr>
                                            <Td border={`1px solid ${borderColor}`}>message_id</Td>
                                            <Td border={`1px solid ${borderColor}`}>An auto-generated 36 alpha numeric string</Td>
                                        </Tr>
                                        <Tr>
                                            <Td border={`1px solid ${borderColor}`}>accepted</Td>
                                            <Td border={`1px solid ${borderColor}`}>The time we received and accepted the message request</Td>
                                        </Tr>
                                    </Tbody>
                                </Table>
                            </TableContainer>
                        </Box>

                        {/* Notes Section */}
                        <Box>
                            <Heading size="md" mb={4}>
                                Notes
                            </Heading>
                            <UnorderedList spacing={2} pl={4}>
                                <ListItem>
                                    The phone number must be provided in international format without the + sign, for example, 923123456789 for PK number
                                </ListItem>
                                <ListItem>
                                    Message must contain all the Required Fields.
                                </ListItem>
                            </UnorderedList>
                        </Box>
                    </VStack>
                </Container>
            </Card>
        </>
    );
};

export default MessageAPIDoc;